import React from "react";
import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import ParkingDrawer from "components/drawer/ParkingDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ParkingDeleteModal from "components/modal/ParkingDeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import ViewParkingModal from "components/modal/ViewParkingModal";
import Tooltip from "components/tooltip/Tooltip";
import { FiEye } from "react-icons/fi";

const ParkingTable = ({ parkingdata, hideDelete, hideEdit }) => {
  const { title, serviceId, handleModalOpen, handleUpdate, handleMenuDetails  } = useToggleDrawer();
  //  console.log("table data", parkingdata);
   
  return (
    <>
      <ViewParkingModal id={serviceId} title={title} data={parkingdata}/>
      <ParkingDeleteModal id={serviceId} title={title} />
   
      <MainDrawer>
        <ParkingDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
      {parkingdata?.map((data, index) => (
        <TableRow key={data.id_parking}>
          <TableCell className="text-center text-xs">{index + 1}</TableCell>
          <TableCell className="text-center text-xs">{data.city_name}</TableCell>
          <TableCell className="text-center text-xs">{data.sight_seeing}</TableCell>
          {/* <TableCell className="text-center text-xs">{data.start_time || "-"}</TableCell> */}
          {/* <TableCell className="text-center text-xs">{data.end_time || "-"}</TableCell> */}
          <TableCell className="text-center text-xs">{data.costs.Sedan}</TableCell>
          <TableCell className="text-center text-xs">{data.costs["Suv & Muv"]}</TableCell>
          <TableCell className="text-center text-xs">{data.costs["Tempo Traveller"]}</TableCell>

          <TableCell>
            <div className="flex justify-center">
              <button
                  onClick={() => handleMenuDetails(data.id_parking, "Parking Details")}
                  className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                >
                  <Tooltip
                    id={data.toll_id}
                    Icon={FiEye}
                    title="ViewOrder"
                    bgColor="#34D399"
                  />
                </button>
              <EditDeleteButton
                id={data.id_parking}
                title={data.city_name}
                handleUpdate={handleUpdate}
                handleModalOpen={handleModalOpen}
                hideEdit={hideEdit}
                hideDelete={hideDelete}
              />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
    </>
  );
};

export default ParkingTable;
